<template>
    <div class="form-item">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <div class="check-group">
            <label
                v-for="opcao in opcoes"
                :key="opcao.value"
                class="check-option"
            >
                <input
                    type="checkbox"
                    class="check-input"
                    :value="opcao.value"
                    :checked="valoresSelecionados.includes(opcao.value)"
                    @change="onChange(opcao.value, $event.target.checked)"
                />

                <span class="check-label">{{ opcao.label }}</span>
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:item']);

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');

const opcoes = computed(() => {
    if (!props.item.opcoes) return [];

    return String(props.item.opcoes)
        .split(';')
        .map(opcao => opcao.trim())
        .filter(Boolean)
        .map(opcao => {
            const partes = opcao.split('=');

            if (partes.length === 2) {
                return {
                    value: partes[0].trim(),
                    label: partes[1].trim()
                };
            }

            return {
                value: opcao,
                label: opcao
            };
        });
});

const valoresSelecionados = computed(() => {
    if (!props.item.resposta_opcoes) return [];

    return String(props.item.resposta_opcoes)
        .split(';')
        .map(v => v.trim())
        .filter(Boolean);
});

function onChange(value, checked) {
    let valores = [...valoresSelecionados.value];

    if (checked && !valores.includes(value)) {
        valores.push(value);
    }

    if (!checked) {
        valores = valores.filter(v => v !== value);
    }

    emit('update:item', {
        ...props.item,
        resposta_opcoes: valores.length ? valores.join(';') : null
    });
}
</script>

<style scoped>
.check-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    align-items: flex-start;
}

.check-option {
    display: inline-flex;
    align-items: flex-start;
    gap: 6px;

    padding: 6px 10px;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    background: #f9f9f9;

    font-weight: normal;
    line-height: 1.25;
    cursor: pointer;
    max-width: 100%;

    transition: .15s;
}

.check-option:hover {
    background: #eef5f4;
    border-color: #4a827c;
}

.check-option:has(input:checked) {
    background: #dff1ef;
    border-color: #4a827c;
    box-shadow: inset 0 0 0 1px #4a827c;
}

.check-input {
    width: 15px !important;
    height: 15px !important;
    min-height: 15px !important;
    padding: 0;
    margin: 2px 0 0 0;

    flex: 0 0 15px;
    cursor: pointer;
}

.check-label {
    display: inline-block;
    max-width: 100%;
    word-break: break-word;
}

.required {
    color: #b00020;
    margin-left: 3px;
}
</style>